module.exports = __webpack_public_path__ + "img/img_zhice_20201207@2x.d74b1933.png";